import { useSignal } from "@preact/signals";
import { useEffect } from "react";
import useOnFiltersReady from "../../lib/hooks/use-on-filters-ready";
export default function WaitForFilters(props) {
    const { timeout = 1000 } = props;
    const filtersReady = useSignal(false);
    useOnFiltersReady(() => (filtersReady.value = true));
    useEffect(() => {
        const timer = setTimeout(() => {
            if (!filtersReady.value) {
                filtersReady.value = true;
            }
        }, timeout);
        return () => clearTimeout(timer);
    }, [timeout, filtersReady]);
    return filtersReady.value === true ? props.component() : null;
}
